import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9572a2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c9572a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9572a2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SpecialMultiCategory: require('/home/korzinka/www/front/components/SpecialMultiCategory.vue').default,SpecialSingleCategory: require('/home/korzinka/www/front/components/SpecialSingleCategory.vue').default})
